(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["block-variant-picker-color-custom"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const productColorTitle = document.querySelector('.product-color-title');
    if (!productColorTitle) return;

    const originalText = productColorTitle.textContent;

    document.querySelectorAll('.variant__button').forEach(link => {
      const variantColorTitle = link.querySelector('.variant-color-title')?.textContent;
      if (!variantColorTitle) return;

      link.addEventListener('mouseenter', () => {
        productColorTitle.textContent = variantColorTitle;
      });
      link.addEventListener('mouseleave', () => {
        productColorTitle.textContent = originalText;
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
